<div
  class="explorer-history-backdrop fixed inset-0 z-40 bg-black/[0.32]"
  (click)="closeOverlay()"
></div>

<div
  class="explorer-history-panel bg-m0 fixed inset-y-0 right-0 z-50 flex w-[calc(26.5%)] flex-col shadow-xl"
>
  <div
    class="border-s200 flex h-[72px] flex-shrink-0 items-center justify-between border-b pl-7 pr-4"
  >
    <div class="flex flex-row items-center">
      <div class="text-s1 select-none text-2xl font-semibold">Chat History</div>

      <div class="relative ml-7 flex h-7 w-7 flex-shrink-0">
        <ngx-spinner
          *ngIf="isRefreshing"
          [name]="spinnerName"
          color="#0084d1"
          bdColor="#00000000"
          size="default"
          type="ball-clip-rotate"
          [fullScreen]="false"
          [disableAnimation]="true"
          [zIndex]="10"
        ></ngx-spinner>
      </div>
    </div>

    <!-- <button
      type="button"
      class="hover:bg-m200 ml-2 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
      (click)="closeOverlay()"
    >
      <m-chevron-right-icon></m-chevron-right-icon>
    </button> -->
  </div>

  <div class="relative flex h-2 flex-1 flex-col">
    <div
      *ngIf="sessionsLoaded && sessions.length === 0"
      class="pointer-events-none absolute inset-0 flex select-none items-center justify-center text-lg"
    >
      History is empty
    </div>

    <div
      *ngIf="sessions.length > 0"
      class="flex h-2 w-full flex-grow flex-col overflow-y-auto"
    >
      <ng-scrollbar
        [orientation]="'vertical'"
        [visibility]="'hover'"
        [appearance]="'compact'"
      >
        <div class="mt-2 h-full w-full pb-6">
          <div *ngFor="let group of sessionGroups; trackBy: trackByGroupTitle">
            <div class="text-s1 mx-7 pb-1 pt-4 text-[17px] font-semibold">{{
              group.title
            }}</div>

            <div
              *ngFor="let session of group.sessions; trackBy: trackBySessionId"
              class="hover:bg-m50 group mx-4 flex h-11 cursor-pointer select-none flex-row items-center rounded pl-3 pr-2"
              (click)="openSession(session)"
            >
              <div class="flex min-w-0 flex-1 flex-row items-center">
                <span
                  class="min-w-0 truncate text-[17px]"
                  [ngClass]="{
                    'text-m600 font-semibold':
                      session.sessionId === currentSession?.sessionId,
                    'text-s1': session.sessionId !== currentSession?.sessionId
                  }"
                  >{{ session.displayTitle }}</span
                >

                <ng-container
                  *ngIf="showSessionEnvRepoBranch({ session: session })"
                >
                  <span
                    class="text-s400 ml-3 max-w-[72px] flex-shrink-0 truncate text-[15px]"
                  >
                    {{ session.envId }}
                  </span>

                  <span
                    class="text-s400 ml-3 max-w-[200px] flex-shrink-0 truncate text-[15px]"
                  >
                    {{ makeSessionRepoBranchName({ session: session }) }}
                  </span>
                </ng-container>
              </div>

              <div
                class="ml-2 flex h-9 w-9 flex-shrink-0 items-center justify-center"
              >
                <button
                  class="hover:bg-m200 invisible flex h-8 w-8 items-center justify-center rounded focus:outline-none group-hover:visible"
                  [tp]="templateSessionMenu"
                  [tpHideOnEscape]="true"
                  tpVariation="menu"
                  className="my-menu"
                  #tpRef="tippy"
                  (click)="$event.stopPropagation()"
                >
                  <m-dots-vertical-icon></m-dots-vertical-icon>
                </button>

                <ng-template #templateSessionMenu>
                  <div
                    class="border-s4 bg-m0 w-48 rounded-md border-2 shadow-xl"
                  >
                    <button
                      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                      (click)="tpRef.hide(); renameSession($event, session)"
                      >Rename Session</button
                    >
                    <button
                      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                      (click)="tpRef.hide(); deleteSession($event, session)"
                      >Delete Session</button
                    >
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </ng-scrollbar>
    </div>
  </div>
</div>

<div *ngIf="sessions$ | async"></div>
<div *ngIf="session$ | async"></div>
